import {
  DateRangeTuple,
  NumberIndexedDictionary,
  SelectItem,
  StringIndexedDictionary,
  TemplateId,
} from "../../globalTypes";
import { DataSourceModel } from "../dataSources/types";
import { AllowSettingsKeys } from "../templateBuilder/types";

export enum TableColumnInputType {
  Category = "category",
  Checkbox = "checkbox",
  DateFrom = "dateFrom",
  DatetimeLocal = "datetime-local",
  DateTo = "dateTo",
  Decimal = "decimal",
  HegFile = "hegFile",
  File = "file",
  Hidden = "hidden",
  Link = "link",
  Number = "number",
  OverviewSelect = "overviewSelect",
  Select = "select",
  Text = "text",
  Textarea = "textarea",
  Title = "title",
  Icon = "icon",
}

export type Table<Name extends string = string> = {
  name: Name;
  schema: string;
  type: string;
  columns: TableColumns;
  rows: TableRow[];
  count: number;
  allowSettings: TableRowAllowSettings;
  currentPage: number | null;
  colorCategories?: ColorCategories;
};

export type Tables = NumberIndexedDictionary<Table>;
export type TableColumns = StringIndexedDictionary<TableColumn>;
export type TableColumnOption = StringIndexedDictionary<string>;

export type TableColumn = {
  isKey: boolean;
  tableName: string;
  columnName: string;
  columnAlias: string;
  sqlColumnName: string;
  displayName: string;
  type: string;
  limitLongWords: boolean;
  unformattedType: string;
  typeText: string;
  isNullable: boolean;
  inputType: TableColumnInputType;
  unformattedInputType: TableColumnInputType;
  inputTypeUnsafe: TableColumnInputType;
  length: number | null;
  maxLength: number | null;
  minLength: number | null;
  isSelect: boolean;
  selectItems: SelectItem[];
  withTemplateUniqueName: string;
  templateItemId: number;
  overviewSelectTemplateId: number | null;
  isAggregationGroup: boolean;
  editable: boolean;
  isArray: boolean;
  templateColumnAlias: string;
  isFromJoin: boolean;
};

export type RowKey = number | string;

export type TableRowAllowSettings = {
  [K in AllowSettingsKeys]: boolean;
};

export type TableRow = {
  templateId: TemplateId | null;
  tableName: string;
  keyValue: RowKey;
  hash: string;
  cells: TableCells;
  allowSettings: TableRowAllowSettings;
};

export type FlowioFile = {
  recordId: number | string;
  filesCount: number;
};

export type ColorCategories = Record<string, string> | undefined;

export type BaseTableCellValue =
  | number
  | string
  | Date
  | null
  | boolean
  | DateRangeTuple
  | FlowioFile;

export type TableCellValue = BaseTableCellValue | BaseTableCellValue[];

export type TableCell = {
  // ColumnName je nějaká kravina, kterou teď nemůžeme smazat.
  // NENÍ unikátní a nelze podle ní identifikovat, v jakém sloupci se cell nachází.
  // Na to musíme použít klíč, pod kterým je cell uložený v TableCells
  columnName: string;
  value: TableCellValue;
  unformattedValue: TableCellValue;
  unmodifiedValue: TableCellValue;
};

export type TableCells = StringIndexedDictionary<TableCell>;

export type DeleteRowPayload = {
  dbContext: string | number;
  tableName: string | number;
  keyValue: string | number;
  templateId: string | number;
};

export type TableByDataSourceId = {
  id: number;
  name: string;
  type: string;
  schema: string;
};

export type TablesByDataSourceID = TableByDataSourceId[];

export type AppTable = {
  id: number;
  name: string;
  datasourceID: number;
  datsource: DataSourceModel;
  datasourceName: string;
  type: string;
  schema: string;
  hash: string;
};

export type AppTables = AppTable[];

export type AdministrationTableRow = {
  columns: TableColumns;
  row: TableRow;
};
